import useSWR from 'swr';
import { selectTransById } from '../services/trans';

export default function useTrans(id) {
  return useSWR(id ? `trans-${id}` : null, () => selectTransById(id));
}
